//
//
//
//
//
//
//
//
//
//
//
//

import ImportDialogWidget from "./ImportDialogWidget.vue";
import { mapActions } from "vuex";

const IMPORT_TYPE_DIMENSIONS = 3;

const MAPPING_FIELDS = [
  {
    label: "Nummer",
    name: "Number",
    column: 'A',
    errors: {}
  },
  {
    label: "Navn",
    name: "Name",
    column: 'B',
    errors: {}
  },
  {
    label: "Beskrivelse",
    name: "Description",
    column: 'C',
    errors: {}
  }
];

const SETTINGS_CONFIG = [
  {
    name: "dimensionId",
    type: "select",
    label: "Dimisjon",
    options: [],
    optionLabel: "value",
    optionValue: "id",
    required: true,
    errorMessage: "Vennligst velg en dimisjon.",
    filterable: true,
    filteredOptions: []
  },
  {
    name: "headerLine",
    type: "toggle",
    label: "Overskriftslinje",
    default: true
  }
];

export default {
  components: {
    ImportDialogWidget
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      IMPORT_TYPE_DIMENSIONS,
      mappingFields: JSON.parse(JSON.stringify(MAPPING_FIELDS)),
      settings: {
        dimensionId: null
      },
      settingsConfig: JSON.parse(JSON.stringify(SETTINGS_CONFIG)),
      description: `
        <p>
          Rutinen leser inn dimensjoner til UNI.
          Utfylte felt skrives over/opprettes. Koblede felt i tabellen
          behandles. Rutinen behandler filer i excel-format.
        </p>
      `
    };
  },
  methods: {
    ...mapActions("main", ["getDimensionSettings"]),
    async fetchDimension() {
      const dimensions = await this.getDimensionSettings();
      const dimensionsSetting = this.settingsConfig.find(s => s.name === "dimensionId");

      console.log(dimensions);

      if (dimensionsSetting) {
       const options = dimensions.map(dimension => ({
          id: dimension.dimension,
          value: dimension.label
        }));

        options.unshift({ id: 2, value: 'Avdeling' });
        options.unshift({ id: 1, value: 'Prosjekt' });

        console.log(options);

        dimensionsSetting.options = options;
        
      }
    }
  },
  mounted() {
    this.fetchDimension();
  }
};
